import { render, staticRenderFns } from "./OnBoardingHeader.vue?vue&type=template&id=0c4d30b6&scoped=true&"
import script from "./OnBoardingHeader.vue?vue&type=script&lang=ts&"
export * from "./OnBoardingHeader.vue?vue&type=script&lang=ts&"
import style0 from "./OnBoardingHeader.vue?vue&type=style&index=0&id=0c4d30b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4d30b6",
  null
  
)

export default component.exports